var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Affinity from "../../../assets/images/logoAffinity.svg";
import { Grid } from "@mui/material";
import { CertificatesTitleLabel, ContainerRows, StyleColumns, StyleColumnsRight, } from "../style";
import { Controller } from "react-hook-form";
import { ButtonAFY, DrawerAFY, icons, InputAFY, LabelAutoCompleteAFY, sizesTextField, variants, variantsTextField, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../../assets/themes/theme";
export var DrawerCertificates = function (props) {
    var validations = {
        required: {
            value: true,
            message: "Requerido",
        },
    };
    var handleSaveButtonClick = function () {
        var _a;
        var fileName = props.getValues("fileName") || "";
        var typeFile = props.getValues("typeFile");
        var typeFileName = typeFile ? typeFile.id : "";
        var ckEditorHtml = (_a = props.editorInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getData();
        props.onSaveData(ckEditorHtml, fileName, typeFileName);
        var body = {
            html: ckEditorHtml,
            name: "Doc#1",
        };
        console.log("Body", JSON.stringify(body));
    };
    return (_jsx(DrawerAFY, __assign({ view: 1, img: Affinity, BgBackdrop: themeCore.colors.backgroundLoader, BgcCloseButton: themeCore.colors.third, bgColorDrawer: themeCore.colors.third, openDrawer: props.openDrawerSb, colorIcon: themeCore.colors.primaryText, title: props.titleDrawer, text: props.descriptionDrawer, onClose: props.onCloseDrawer }, { children: _jsxs(Grid, __assign({ container: true, spacing: 1 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsxs(ContainerRows, { children: [_jsx(StyleColumns, { children: _jsx(CertificatesTitleLabel, __assign({ style: {
                                        color: props.productTitleColor,
                                    } }, { children: props.labelFileName })) }), _jsx(StyleColumnsRight, { children: _jsx(Controller, { name: "fileName", control: props.control, rules: validations, render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (_jsx(InputAFY, __assign({}, field, { id: "fileName", disableLine: true, fullWidth: true, onBlur: function (e) {
                                                var value = e.target.value;
                                                if (value === "") {
                                                    props.setError("fileName", {
                                                        type: "manual",
                                                        message: props.errorTextFileName,
                                                    });
                                                }
                                                else {
                                                    props.clearErrors("fileName");
                                                }
                                            }, defaultValue: (_b = props.dataForm) === null || _b === void 0 ? void 0 : _b.fileName, size: sizesTextField.small, variant: variantsTextField.filled, helperText: props.errors.fileName === undefined
                                                ? ""
                                                : props.errorTextFileName, register: props.register, error: props.errors.fileName, validations: {
                                                required: {
                                                    value: true,
                                                    message: props.errorTextFileName,
                                                },
                                            } })));
                                    } }) })] }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsxs(ContainerRows, { children: [_jsx(StyleColumns, { children: _jsx(CertificatesTitleLabel, __assign({ style: {
                                        color: props.productTitleColor,
                                    } }, { children: props.labelTypeCertificate })) }), _jsx(StyleColumnsRight, { children: _jsx(Controller, { name: "typeFile", control: props.control, rules: validations, render: function (_a) {
                                        var _b, _c, _d;
                                        var field = _a.field;
                                        return (_createElement(LabelAutoCompleteAFY, __assign({}, field, { id: "typeFile", helperText: props.errors.typeFile === undefined
                                                ? ""
                                                : props.errorTextTypeFile, error: !!props.errors.typeFile, labelText: "", size: sizesTextField.medium, disableLine: true, loading: false, onBlur: function (e) {
                                                if (e === "") {
                                                    props.setError("typeFile", {
                                                        type: "manual",
                                                        message: props.errorTextTypeFile,
                                                    });
                                                }
                                                else {
                                                    props.clearErrors("typeFile");
                                                }
                                            }, onSelectOption: function (options) {
                                                if (Object.keys(options).length > 0) {
                                                    field.onChange(options);
                                                    props.clearErrors("typeFile");
                                                }
                                                else {
                                                    props.setError("typeFile", {
                                                        type: "manual",
                                                        message: props.errorTextTypeFile,
                                                    });
                                                }
                                            }, variantLabel: variantsTextField.filled, dataList: props.TypeListDrawer, key: (_c = (_b = props.dataForm) === null || _b === void 0 ? void 0 : _b.typeFile) === null || _c === void 0 ? void 0 : _c.id, defaultValue: (_d = props.dataForm) === null || _d === void 0 ? void 0 : _d.typeFile })));
                                    } }) })] }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx("div", __assign({ style: {
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "15px",
                        } }, { children: _jsx(ButtonAFY, { backgroundColor: themeCore.colors.third, disabled: !props.isValid, color: themeCore.colors.primaryText, icon: icons.Save, label: props.titleSaveButton, onClick: handleSaveButtonClick, widthButton: "100px", variant: variants.contained }) })) }))] })) })));
};
